import script from "./myDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./myDialog.vue?vue&type=script&lang=ts&setup=true"

import "./myDialog.vue?vue&type=style&index=0&id=46b986da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b986da"]])

export default __exports__